import styled, { css } from 'styled-components';
import { Flex } from '@spotnana/pixel-react/dist/Box';
import Typography from '@spotnana/pixel-react/dist/Typography';

export const Wrapper = styled.div(
  ({ theme }) => css`
    padding: 40px;
    background: ${theme.colors.bg.white};
    border: 1px solid ${theme.colors.bg.lightBlueGrey};
    border-radius: ${theme.radii.lg}px;
  `,
);

export const TripName = styled(Typography).attrs({
  variation: 'h4',
})(
  ({ theme }) => css`
    margin-top: 8px;
    font-weight: ${theme.fontWeights.semiBold};
    line-height: 24px;
  `,
);

export const DetailsGroup = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const DetailsHeading = styled(Typography).attrs({
  variation: 'small',
})(
  ({ theme }) => css`
    color: ${theme.colors.text.lightGrey};
    font-weight: ${theme.fontWeights.strong};
    text-transform: uppercase;
  `,
);

export const TripIdContainer = styled(Flex)`
  align-items: center;
`;

export const DetailsLabel = styled(Typography).attrs({
  variation: 'small',
})(
  ({ theme }) => css`
    margin-right: 8px;
    color: ${theme.colors.text.lightGrey};
    font-weight: ${theme.fontWeights.semiBold};
    line-height: 20px;
  `,
);

export const DetailsValue = styled(Typography).attrs({
  variation: 'small',
})(
  ({ theme }) => css`
    color: ${theme.colors.text.lightGrey};
    line-height: 20px;
  `,
);
